import { stats } from '../../content/stats.js';

export function TrustStats() {
  return (
    <section
      style={{
        maxWidth: '1180px',
        margin: '0 auto',
        padding: 'clamp(16px,2.4vw,22px) clamp(18px,5vw,64px) 0',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%,170px), 1fr))',
          gap: '15px',
        }}
      >
        {stats.items.map((item) => (
          <div
            key={item.label}
            style={{
              borderRadius: '22px',
              padding: '26px',
              background: 'var(--glass)',
              border: '1px solid var(--edge)',
              backdropFilter: 'blur(var(--blur))',
              WebkitBackdropFilter: 'blur(var(--blur))',
              boxShadow: 'var(--cardShadow)',
            }}
          >
            <div
              style={{
                font: "800 clamp(30px,4vw,42px)/1 'Plus Jakarta Sans',sans-serif",
                letterSpacing: '-.035em',
                color: 'var(--statInk)',
              }}
            >
              {item.value}
            </div>
            <div
              style={{
                marginTop: '9px',
                font: "600 13.5px/1.4 'Plus Jakarta Sans',sans-serif",
                color: 'var(--muted)',
              }}
            >
              {item.label}
            </div>
          </div>
        ))}
      </div>
      {stats.placeholder && (
        <div
          style={{
            marginTop: '13px',
            font: "500 12px/1.4 'Plus Jakarta Sans',sans-serif",
            color: 'var(--faint)',
          }}
        >
          Placeholder figures — swap for real numbers before launch.
        </div>
      )}
    </section>
  );
}
